import Axios from "axios";
import Vue from "vue";

Vue.mixin({
    beforeCreate() {
        const options = this.$options;
        if (options.wordService) {
            this.$wordService = options.wordService;
        } else if (options.parent && options.parent.$wordService) {
            this.$wordService = options.parent.$wordService;
        }
    },
});

export default class WordService {
    constructor(fileUtils) {
        this.FileUtils = fileUtils;
    }

    getURL() {
        //location = process.env.has ? process.env.VUE_APP_API_URL_HTTPS : process.env.VUE_APP_API_URL;
        let location = process.env.VUE_APP_API_URL || window.location.origin;
        if (!location.endsWith("/")) {
            location = location + "/";
        }
        return location + "api/words";
    }

    async addWord(name, file_gailtal, file_jauntal, file_rosental, password) {
        const body = {
            Title: name,
            FileGt: await this.FileUtils.readFileAsync(file_gailtal),
            FileJt: await this.FileUtils.readFileAsync(file_jauntal),
            FileRt: await this.FileUtils.readFileAsync(file_rosental),
            TypeGt: this.FileUtils.getFileType(file_gailtal),
            TypeJt: this.FileUtils.getFileType(file_jauntal),
            TypeRt: this.FileUtils.getFileType(file_rosental),
            Password: password
        };
        await Axios.post(this.getURL(), body);
    }

    async getAllWords() {
        const response = await Axios.get(this.getURL());
        return response.data;
    }
}
